import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  filled: {
    background:
      theme.palette.mode === "dark"
        ? "rgba(35,224,210,0.08)"
        : theme.palette.text.primary,
    color: theme.palette.mode === "dark" ? "#CFE7E8" : "white",
    ":hover": {
      background:
        theme.palette.mode === "dark"
          ? "rgba(35,224,210,0.08)"
          : theme.palette.text.primary,
    },
  },
}));

export const reasonGroups = [
  {
    label: "ACCURACY & CORRECTNESS",
    key: "accuracy",
    reasons: [
      { key: "completely_incorrect", label: "Completely incorrect" },
      { key: "partially_incorrect", label: "Partially incorrect" },
      { key: "factual_errors", label: "Contains factual errors" },
      { key: "outside_info", label: "Contains Info outside question scope" },
    ],
  },
  {
    label: "RELEVANCE",
    key: "relevance",
    reasons: [
      { key: "completely_irrelevant", label: "Completely irrelevant" },
      { key: "somewhat_relevant", label: "Somewhat relevant" },
      {
        key: "not_addressing_question",
        label: "Vague, doesn't address the question",
      },
    ],
  },
  {
    label: "COMPLETENESS",
    key: "completeness",
    reasons: [
      { key: "incomplete_answer", label: "Incomplete answer" },
      { key: "missing_details", label: "Missing important details" },
      { key: "lacks_depth", label: "Lacks depth" },
      { key: "no_answer", label: "No answer provided" },
    ],
  },
  {
    label: "LENGTH & FORMAT",
    key: "format",
    reasons: [
      { key: "too_long", label: "Too long/verbose" },
      { key: "too_short", label: "Too brief" },
      { key: "poor_formatting", label: "Poor formatting" },
      { key: "hard_to_understand", label: "Hard to understand" },
    ],
  },
  {
    label: "CITATIONS & SOURCES",
    key: "citations",
    reasons: [
      { key: "missing_sources", label: "Missing sources" },
      { key: "incorrect_sources", label: "Incorrect sources" },
      {
        key: "incorrect_citations",
        label: "Wrong or incomplete citation block",
      },
    ],
  },
];

// Usage: <FeedbackChips chips={selectedKeys} readonly />
function FeedbackChips({ chips = [], readonly = true, onChipClick }) {
  const { classes } = useStyles();

  return (
    <>
      {reasonGroups.map((group) => {
        const { label, reasons } = group;
        return (
          <Box key={group.key} mb={2}>
            <Typography
              variant="caption"
              fontWeight={600}
              mb={1}
              display="block">
              {label}
            </Typography>
            <Box mb={1} />
            <Box
              rowGap={1}
              columnGap={1}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"flex-start"}
              flexWrap="wrap">
              {reasons.map((reason) => {
                const isSelected = chips.includes(reason.key);
                return (
                  <Chip
                    key={reason.key}
                    label={reason.label}
                    variant={isSelected ? "filled" : "outlined"}
                    size="small"
                    sx={{ fontSize: 14, height: "32px", mb: 0.5, mr: 1 }}
                    className={isSelected ? classes.filled : undefined}
                    onClick={
                      readonly ? undefined : () => onChipClick?.(reason.key)
                    }
                    tabIndex={readonly ? -1 : 0}
                  />
                );
              })}
            </Box>
          </Box>
        );
      })}
    </>
  );
}

export default FeedbackChips;
